import { createSelector, EntityId } from '@reduxjs/toolkit';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { variablePlugins } from '@ff-scene-plugins/gift-shared/registry';

export const selectApiStatusForInputs = createSelector([
    (state: GiftPdpState) => state.project.variables,
    (state: GiftPdpState) => state.project.inputs
], (variables, inputs): 'pending' | 'ready' | 'error' => {

    const getStatus = (variableId: EntityId) => {
        const variable = variables.entities[variableId]!;
        const input = inputs.entities[variableId]!;
        const plugin = variablePlugins.require(variable.pluginId);
        return plugin.privateUploadHandler?.status(input) ?? 'ready';
    };

    const statuses = variables.ids.map(getStatus);

    if (statuses.includes('error')) {
        return 'error';
    } else if (statuses.includes('pending')) {
        return 'pending';
    } else {
        return 'ready';
    }
});